<template>
  <div class="goods-attr">
    <!-- 浮窗顶部 -->
    <div class="attr-header">
      <div class="goods-image" :style="{height:imageHeight}">
        <span v-if="goods.ispre_order == 1 && goods.preorderItem == true && parseInt(goods.counts) != 0" class="preorder">PRE-ORDER</span>
        <img :src="goods.thumb" alt=""/>
      </div>
      <div class="right-close-btn">
        <!-- <van-button class="new-back-btn" icon="arrow-left" size="small" plain type="danger" @click="goBack">{{ $t("translate.back") }}</van-button> -->
        <van-button class="new-back-btn" icon="cross" round size="small" plain type="danger" @click="goBack"></van-button>
      </div>

      <div ref="posTop" class="pos-top">
        <!-- <div class="right-close-btn" v-if="goods.goods_attr_list.length || goods.isEdit"> -->
        <div class="flex flex-start justify-between">
          <div class="item-name">{{goods.title}}</div>
          <div style="display:flex">
            <span  v-if="goods && goods.productprice"
            style="font-size:15px;-webkit-text-decoration-line: line-through; /* Safari */; 
            text-decoration-line: line-through;color:#ee2d24;margin-top:3px "
            >{{ fmPrice(goods.productprice)}}</span>
            <div class="item-price">
            <span>{{ fmPrice(goods.price || goods.marketprice)}}</span>
            <div v-if="goods.goods_attr_list.length" class="base-price">{{ $t("translate.base_price") }}</div>
          </div>
          </div>
        </div>
        <div>
          <div>
            <span v-if="goods.istime > 0 || goods.fullWeek == false" class="item-preorder">Available on: </span>
            <span v-if="parseInt(goods.counts) != 0 && goods.istime == 1"><span class="preOrder">{{goods.startdate}} - {{goods.enddate}}</span><span class="preOrder">{{goods.begintime}} - {{goods.endtime}}</span></span>
            <span v-if="parseInt(goods.counts) != 0 && goods.istime == 2" class="preOrder">{{goods.startdate}} - {{goods.enddate}}</span>
            <span v-if="parseInt(goods.counts) != 0 && goods.istime == 3" class="preOrder">{{goods.begintime}} - {{goods.endtime}}</span>
            <span v-if="parseInt(goods.counts) != 0 && goods.fullWeek == false" class="preOrder">{{goods.days}}</span>
          </div>
          <div v-if="parseInt(goods.counts) != 0 && goods.preparation_time > 0 && goods.prepare_time_display == 1">
            <span class="item-prepare">Preparation Time: </span>
            <span v-if="goods.preparation_time < 60" class="prepare">{{goods.preparation_time}} Minutes</span>
            <span v-if="goods.preparation_time >= 60" class="prepare">{{goods.preparation_time_display}}</span>
          </div>
        </div>
  
        <div class="item-desc">
          <p>{{goods.description || ''}}</p>
        </div>
      </div>
    </div>

    <div v-if="goods.isoptions == 1" class="attr-body">
      <!-- 属性列表 -->
      <div class="item-attr" v-for="(attr, index) in attrList" :key="index">
        <!-- 属性标题 -->
        <div class="item-body">
          <div v-if="attr.items[0]['ov_status']==1" class="attr-title">{{attr.title}}</div>
          <div>
            <span v-if="attr.items[0]['is_required']==1" class="attr-required">{{ $t("translate.required") }}*</span>
            <span v-else class="attr-optional" >{{ $t("translate.optional") }}</span>
          </div>
        </div>

        <div v-if="attr.items[0]['ov_status']==1" class="attr-list">
          <AddonsRadio v-if="attr.items[0]['is_multiple']==0" :arrItems="attr.items" :strName="attr.title" @evtChooseAttr="chooseAttr" />
          <AddonsCheckbox v-if="attr.items[0]['is_multiple']==1" :arrItems="attr.items" :strName="attr.title" @evtChooseAttr="chooseAttrCheckbox" />
        </div>
      </div>
          
          <!-- temporary -->
        <div style="height:100px"></div> 
    </div>
    
    <div class="attr-body" style="display:none">
        <div class="item-special_instruction">
            <div class="item-special_title" :class="{'border-top':goods.isoptions == 1}">{{ $t("translate.special_instruction") }}</div>
            <div class="item-special_text">{{ $t("translate.preference") }}</div>
            <v-textarea rows="3" outlined solo flat label="e.g No Coriander please"></v-textarea>
        </div>
    </div>
    
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { cartMixin } from "@/mixins/cartMixin";
import AddonsRadio from "./AddonsRadio";
import AddonsCheckbox from "./AddonsCheckbox";
import { NOT_FOUND_IMAGE_URL } from '@/constants'
// <GoodsAddons :arrItems="attr.items" @evtChooseAttr="chooseAttr"/>
export default {
  props: {
    // 当前商品
    goods: {
      type: Object,
      default: () => {
        return {
          title: "",
          name: "",
          price: 0
        };
      }
    },
    //当前[item]所有的属性列表
    attrList: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    //当前已选中的属性列表
    chooseList: {
      type: Array,
      required: false,
      default: () => {
        return new Array();
      }
    }
  },
  data () {
    return {
      radio: {
        item0: "",
        item1: "",
        item2: "",
        item3: "",
        item4: "",
        item5: "",
        item6: "",
        item7: "",
        item8: "",
        item9: ""
      },
      curAttr: {},
      mulAttr: [],
      notfoundimage:
        "https://restaurant.fastorder.my/attachment/images/2/2020/01/rhfi799j4R9I4RPrKH9357Zwz8jIPi.jpg",
      imageHeight: "150px",
      requiredOptionList: {} //所有必选项的状态
    };
  },
  components: {
    AddonsRadio,
    AddonsCheckbox
  },
  mounted:function () {
    // setTimeout(this.setTabsPosTop, 100)
    window.addEventListener('popstate', ()=> { this.closePopup() });
  },
  created () {
    this.mulAttr = [];
    if (this.chooseList.length) {
      this.mulAttr = this.chooseList;
      // console.log('来自购物车item已选中的规格', this.mulAttr);
    }
    this.getScreenSize(0.3);
    this.iniGoods()
  },
  destroyed () {
    window.removeEventListener('popstate', ()=> { this.closePopup() });
  },
  mixins: [cartMixin],
  methods: {
    iniGoods () {
      let listOption = {} //初始化所有的option的值, 其中 is_required=0 时默认值为 true
      this.attrList && this.attrList.length && this.attrList.forEach(item => {
        listOption[item.title] = false
        item.items && item.items.length > 0 && item.items.forEach(im => {
          listOption[item.title] = im.is_required == 0
        })
      })
      this.chooseList && this.chooseList.forEach(item => {
        const kkname = Object.keys(item)[0]
        if (item.optionid != "") {
          listOption[kkname] = true
        }
      })
      const moment = require('moment');
      let dateStart = new Date(this.goods.startdate * 1000)
      let dateEnd = new Date(this.goods.enddate * 1000)
      if (dateStart.toString() == 'Invalid Date' || dateEnd.toString() == 'Invalid Date'){
        dateStart = new Date(this.goods.startdate)
        dateEnd = new Date(this.goods.enddate)
      }
      let currentDateTime = new Date()
      this.goods.startdate = moment(dateStart).format('MMM DD, YYYY')
      this.goods.enddate = moment(dateEnd).format('MMM DD, YYYY')
      this.goods.preorderItem = false;
      if (!this.goods.week.includes(currentDateTime.getDay())){
        this.goods.preorderItem = true;
      }
      this.goods.week = this.goods.week.replace('1','Monday')
      this.goods.week = this.goods.week.replace('2','Tuesday')
      this.goods.week = this.goods.week.replace('3','Wednesday')
      this.goods.week = this.goods.week.replace('4','Thursdays')
      this.goods.week = this.goods.week.replace('5','Friday')
      this.goods.week = this.goods.week.replace('6','Saturday')
      this.goods.week = this.goods.week.replace('0','Sunday')
      this.goods.weekArray = this.goods.week.split(',')
      let dayWeek = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];
      if (this.goods.preparation_time >= 60){
        let hours = Math.floor(this.goods.preparation_time/60)
        let minutes = this.goods.preparation_time - Math.floor(hours*60)
        if (hours < 24){
          if (minutes == 0){
            this.goods.preparation_time_display = hours + ' Hours';
          } else {
            this.goods.preparation_time_display = hours + ' Hours ' + minutes + ' Minutes';
          }
        } else if (hours >= 24) {
          let days = Math.floor(hours/24);
          hours = hours - (days*24);
          if (hours == 0 && minutes == 0){
            this.goods.preparation_time_display = days + ' Days';
          } else if (hours > 0 && minutes == 0){
            this.goods.preparation_time_display = days + ' Days ' + hours + ' Hours';
          } else if (hours > 0 && minutes > 0){
            this.goods.preparation_time_display = days + ' Days ' + hours + ' Hours ' + minutes + ' Minutes';
          } else if (hours == 0 && minutes > 0){
            this.goods.preparation_time_display = days + ' Days ' + minutes + ' Minutes';
          }
        }
      }
      if (this.goods.weekArray.length <= 3){
        this.goods.fullWeek = false
        if (this.goods.week == 'Saturday,Sunday'){
          this.goods.days = 'Weekends Only'
        } else {
          this.goods.days = this.goods.week + ' Only'
        }
      } else {
        if (this.goods.weekArray.length == 7){
          this.goods.fullWeek = true
        } else {
          this.goods.fullWeek = false
          this.goods.days = 'All days except '
          let count = 0;
          for(let i=0;i<dayWeek.length;i++){
            if (!this.goods.week.includes(dayWeek[i])){
              if (count == 0){
                this.goods.days += dayWeek[i];
                count++;
              } else {
                this.goods.days += ', ' + dayWeek[i];
                count++;
              }
            }
          }
        }
      }
      if (this.goods.ispre_order == 1 && this.goods.preorderItem == false){
        let timeStart = this.goods.begintime.replace(':','').padStart(4,'0')
        let timeEnd = this.goods.endtime.replace(':','').padStart(4,'0')
        this.goods.begintime = moment(this.goods.begintime,'HH:mm').format('hh:mmA')
        this.goods.endtime = moment(this.goods.endtime,'HH:mm').format('hh:mmA')
        let currentTime = Number(currentDateTime.getHours().toString().padStart(2,'0') + currentDateTime.getMinutes().toString().padStart(2,'0'))
        let dateTimeStart = new Date(dateStart.getFullYear(),dateStart.getMonth(),dateStart.getDate(),timeStart.substring(0,2),timeStart.substring(2,4))
        let dateTimeEnd = new Date(dateEnd.getFullYear(),dateEnd.getMonth(),dateEnd.getDate(),timeEnd.substring(0,2),timeEnd.substring(2,4))
        console.log('Current Datetime ',currentDateTime)
        if (this.goods.istime == 1){
          if (dateTimeStart <= currentDateTime && dateTimeEnd >= currentDateTime){
            if (Number(timeStart) <= currentTime && Number(timeEnd) >= currentTime){
              this.goods.preorderItem = false
            } else {
              this.goods.preorderItem = true
            }
          } else {
            this.goods.preorderItem = true
          }
        } else if (this.goods.istime == 2){
          if (dateStart <= currentDateTime && dateEnd >= currentDateTime){
            this.goods.preorderItem = false
          } else {
            this.goods.preorderItem = true
          }
        } else if (this.goods.istime == 3){
          if (Number(timeStart) <= currentTime && Number(timeEnd) >= currentTime){
            this.goods.preorderItem = false
          } else {
            this.goods.preorderItem = true
          }
        }
      }
      console.log('this.goods',this.goods)
      this.requiredOptionList = listOption
      this.checkRequiredOptionList()
    },
    checkRequiredOptionList () {
      //检查所有option是否都为true,并抛出emit事件上层组件
      const listVal = Object.values(this.requiredOptionList)
      let reqVal = true
      if (this.goods.isoptions == 1){
        listVal && listVal.length > 0 && listVal.forEach(item => {
          if (item == false) {
            reqVal = false
          }
        }) 
      }
      console.log('emit------------', reqVal);
      setTimeout(() => {
        this.$emit("evtIsRequired", reqVal)
      }, 200);
    },
    /**
     * 获取相对于屏幕的高度
     * @param {屏幕高度的百分比} size_num
     */
    getScreenSize (size_num) {
      size_num = size_num <= 0 ? 1 : size_num;
      const h =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      const imagehpx = parseInt(h * size_num) + "px";
      this.imageHeight = imagehpx;
    },
    closePopup () {
      this.$emit("evtClosePopup");
    },
    goBack(){
      this.$emit("evtGoBack")
    },
    chooseAttr (newAttr, addon_name, bool_val) {
      this.requiredOptionList[addon_name] = bool_val
      this.attrList && this.attrList.forEach(atm => {
        if (atm.title == addon_name && atm.items[0].is_required == 0) {
          this.requiredOptionList[addon_name] = true
        }
      })

      const delTodo = () => {
        // 从 mulAttr 中查找和删除同规格的内容
        let afterDelAddon = [];
        this.mulAttr && this.mulAttr.length && this.mulAttr.forEach(mitem => {
          let is_exist = false;
          Object.keys(mitem).forEach(kname => {
            if (kname === addon_name) {
              is_exist = true;
            }
          });
          if (is_exist === false) {
            afterDelAddon.push(mitem);
          }
        });
        this.mulAttr = afterDelAddon;
      };
      delTodo();
      if (bool_val) {
        this.mulAttr.push(newAttr);
      }
      if (this.mulAttr.length < 1) {
        this.checkMulAttr()
        this.$emit("evtChooseAttr0", { sku: this.goods.sku, sky: this.goods.sky, attr: [] });
      } else {
        this.checkMulAttr()
        this.$emit("evtChooseAttr0", { sku: this.goods.sku, sky: this.goods.sky, attr: this.mulAttr });
      }
    },
    existAttr (addon_name) {
      //检查规格[addon_name]在当前的[mulAttr]是否存在
      let exist_val = false
      this.mulAttr && this.mulAttr.length && this.mulAttr.forEach((item, index) => {
        const ikList = Object.keys(item)
        if (ikList.includes(addon_name) === true) {
          exist_val = true
        }
      })
      return exist_val
    },
    delCheckboxExistAttr (addon_name) {
      //过滤掉已存在的规格， checkbox是有效
      const filterRes = this.mulAttr && this.mulAttr.length && this.mulAttr.filter(im => {
        const imKeys = Object.keys(im)
        if (imKeys.includes(addon_name) == false) {
          return im
        }
      })
      return filterRes
    },
    chooseAttrCheckbox (newAttr, addon_name, bool_val) {
      const isExist = this.existAttr(addon_name)
      let filterRes = this.delCheckboxExistAttr(addon_name)
      this.requiredOptionList[addon_name] = newAttr.length ? true : false
      this.attrList && this.attrList.forEach(atm => {
        if (atm.title == addon_name && atm.items[0].is_required == 0) {
          this.requiredOptionList[addon_name] = true
        }
      })

      if (bool_val) {
        if (this.mulAttr.length < 1) {
          this.mulAttr = newAttr;
        } else {
          newAttr.forEach(im => filterRes.push(im))
          this.mulAttr = filterRes
        }
      }
      if (this.mulAttr.length < 1) {
        this.checkMulAttr()
        this.$emit("evtChooseAttr0", { sku: this.goods.sku, sky: this.goods.sky, attr: [] });
      } else {
        this.checkMulAttr()
        this.$emit("evtChooseAttr0", { sku: this.goods.sku, sky: this.goods.sky, attr: this.mulAttr });
      }
    },
    checkMulAttr () {
      console.log('检测结果1111111', this.requiredOptionList);
      console.log('检测结果2222222', Object.values(this.requiredOptionList));
      this.checkRequiredOptionList()
    }
  }
};
</script>
<style lang="less">
@import url('../../assets/css/common.less');

.goods-attr {
  font-family:Arial;
  background-color: @fff;
  // width: 800px;
  height: 100%;
  @media only screen and (max-width: 2560px) {
    width: 1200px;
  }
  @media only screen and (max-width: 1920px) {
    width: 900px;
  }
  @media only screen and (max-width: 1600px) {
    width: 700px;
  }
  @media only screen and (max-width: 1280px) {
    width: 500px;
  }
  @media only screen and (max-width: 820px) {
    width: 100vmin;
  }
  .attr-required {
    color: @red;
    font-size: 14px;
  }
  .attr-optional {
    color: @green4;
    font-size: 14px;
  }
  .attr-optional_disabled{
    font-size: 14px;
    color: @gray12;
  }
  .preorder {
    font-size:12px;
    font-weight: bold;
    position:absolute;
    left:5px;
    padding:3px;
    background-color: #FF0000;
    color: #FFFFFF;
    border-radius: 3px;
  }
  .preOrder {
    font-size:12px;
    font-weight: bold;
    margin-right: 3px;
    padding:0 2px;
    background-color: #008000;
    color: #FFFFFF;
    border-radius: 3px;
  }
  .prepare {
    font-size:12px;
    font-weight: bold;
    margin-right: 3px;
    padding:0 2px;
    background-color: #ff8c00;
    color: #FFFFFF;
    border-radius: 3px;
  }
  .attr-header {
    background-color: @fff;
    .goods-image {
      margin: 0;
      padding: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right-close-btn {
      text-align: left;
      padding: 0;
      line-height: 10px;
      margin-bottom: 10px;
      position: absolute;
      top: 10px;
      left: 10px;
      .new-back-btn {
        border: 0;
        background-color: rgba(0, 0, 0, 0.4);
        color: @fff;
      }
    }
    .pos-top {
      // padding: 15px 8px 0px 8px;
      padding: 15px 16px 0px 16px;
      text-align: left;
      background-color: @fff;
      position: relative;
      // border-radius: 20px 20px 0 0;
      .item-name {
        font-weight: bold;
        font-size: 18px;
      }
      .item-preorder {
        font-weight: bold;
        font-size: 12px;
        padding: 0 2px;
        margin-right: 3px;
      }
      .item-prepare {
        font-weight: bold;
        font-size: 12px;
        padding: 0 2px;
        margin-right: 3px;
      }
      .close-icon {
        font-weight: normal;
        padding: 5px 5px;
        background-color: rgba(255, 255, 255, 0.38);
        border-radius: 100%;
        margin-right: 13px;
      }
      .item-price {
        padding: 0 0 0 8px;
        font-weight: bold;
        font-size: 20px;
        .base-price {
          width: 60px;
          font-size: 12px;
          // color: #666666;
          color: @gray8;
          font-weight: normal;
        }
      }
      .item-desc {
        font-size: 12px;
        // color: #666666;
        color: @gray8;
        font-weight: normal;
        padding-bottom: 16px;
        border-bottom: 1px solid @white11;
        p {
          margin: 10px 0 0 0;
          padding: 0;
        }
      }
    }
  }
  .attr-body {
    // padding: 0px 0 200px 0;
    padding: 0 0 20px 0;
    // background-color: #f0f0f0;
    text-align: left;
    .item-attr {
      // padding: 0 10px 10px 10px;
      padding: 0 16px 10px 16px;
      background-color: @fff;
      margin: 0 0 10px 0;
      .item-body{
        border: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 16px;
      }
      .attr-price {
        text-align: center;
      }
      .attr-title {
        margin-bottom: 10px;
        font-weight: 550;
      }
    }
    .item-special_instruction{
      margin-bottom: 100px;
      padding: 0px 16px 10px 16px;
      .item-special_title{
        padding-top: 16px;
        font-weight: 550;
        margin-bottom: 7px;
      }
      .border-top{
        border-top:1px solid @white11;
      }
      .item-special_text{
        font-weight: 200;
        margin-bottom: 18px;
      }
    }
  }
}
</style>